/// <reference path="../_references.ts"/>

module App.Helpers {
	import Appointment = App.Appointments.Appointment;
	import AppRootScope = App.Administrative.AppRootScope;
	import OrganizationFileUploadData = App.Utils.OrganizationFileUploadData;

	export class TitleBarService {
		static Factory() {
			let instance = () => new TitleBarService();

			instance.$inject = [];

			return instance;
		}

		protected title: string = "Home";
		protected cssClass: string = null;

		public set(title: string, cssClass?: string) {
			this.title = title;
			this.cssClass = cssClass;
		}

		public getTitle(): string {
			return this.title;
		}

		public getCss(): string {
			return this.cssClass;
		}
	}

	export class TitleBarController {
		static $inject: string[] = ['TitleBarService', 'SelectedAppointment', 'BottomDrawerService',
			'$state', 'UploadService', 'DefaultToasts', '$rootScope', 'CustomerService', 'OrganizationService'];

		protected isInfoOpen: boolean = false;
		protected savingFile: boolean = false;
		protected appointment?: Appointment = null;
		protected organization: OrganizationFileUploadData = null;
		protected errorFile: Object = {};

		constructor(
			public TitleBarService: TitleBarService,
			protected SelectedAppointment: App.Appointments.SelectedAppointment,
			protected BottomDrawerService: BottomDrawerService,
			protected $state: ng.ui.IStateService,
			protected UploadService: UploadService,
			private DefaultToasts: App.Utils.DefaultToasts,
			private $rootScope: AppRootScope,
			private CustomerService: App.Customer.CustomerService,
			private OrganizationService: App.Utils.OrganizationService

		) {
			this.SelectedAppointment.addListener(this.setAppointment.bind(this));
			this.SelectedAppointment.getAppointment()
				.then((appointment) => this.setAppointment(appointment));
			this.OrganizationService.getFileUploadDetails()
				.then((organization) => this.organization = organization.data);
		}

		public getPage(): string {
			return this.$state.current.name;
		}

		public setAppointment(appointment: Appointment): void {
			if (appointment && appointment.id && !appointment.is_partial) {
				this.appointment = appointment;
			} else {
				this.appointment = null;
			}
		}

		public toggleInfo(): void {
			if (this.isInfoOpen) {
				this.closeInfo();
			} else {
				this.openInfo();
			}
		}

		public openInfo(): void {
			if (!this.appointment || !this.appointment.id || this.BottomDrawerService.isOpen) {
				return;
			}
			this.isInfoOpen = true;
		}

		public closeInfo(): void {
			this.isInfoOpen = false;
		}

		displayMaxSizeError() {
			this.DefaultToasts.displayWarning('Reduce File Size and Try Again');
			this.errorFile = {};
		};

		uploadImage(files: File[]) {
			let count: number = 0,
				uploadedCount: number = 0,
				cId: number = this.appointment.service_request.customer.id;

			files.forEach((file) => {
				let filetype = file.type.split('/'),
					time = new Date().getTime(),
					filename = this.organization.id + '/' + cId + '/' + this.$rootScope.app.generateGuid() +
						'.' + time + '.' + file.name.split('.').pop();

				count++;
				this.DefaultToasts.displayLoading('File ' + count + '/' + files.length + ' uploading');
				this.savingFile = true;
				this.UploadService.uploadAWS('zip-customer-uploads', filename, file).then((response: any) => {
					let data = {
						url: response.headers('Location'),
						name: file.name,
						size: file.size,
						file_type: filetype[0] === 'application' ? filetype[1] : filetype[0]
					};

					this.CustomerService.addFile(cId, data).then((images) => {
						this.appointment.service_request.customer.files.unshift(images.data);
						uploadedCount++;

						if (count === uploadedCount) {
							this.savingFile = false;
							this.DefaultToasts.hideLoading();
							this.DefaultToasts.displaySuccess('File ' + count + '/' + files.length + ' uploaded');
						}
					});
				})
				.catch((err) => this.DefaultToasts.displayError(err, 'Failed to upload file: '));
			});
		};
	}

	angular.module('helpers.titleBar', [])
		.factory('TitleBarService', TitleBarService.Factory())
		.controller('TitleBarController', TitleBarController);
}
